/*eslint-disable*/
import moment from 'moment';
import React, { useEffect } from 'react';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { IoLogoWhatsapp } from 'react-icons/io';
import { MdEmail, MdPhoneInTalk } from 'react-icons/md';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import { useTranslation } from 'react-i18next';
import { BiTransfer } from 'react-icons/bi';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { RiVipCrownFill } from 'react-icons/ri';
import { TbCalendarTime } from 'react-icons/tb';
import { TiStarFullOutline } from 'react-icons/ti';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { imageUrl } from '../../config/apiUrl';
import { mapPin } from '../../constant/imagePath';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { useFavoriteEntityMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';
import { usdToOther } from '../../utils/helpers';
import IconList from '../IconList/IconList';
import Tooltip from '../Tooltip';
import classes from './EventHorizontalCard.module.css';

const EventHorizontalCard = ({
  index,
  data,
  className = '',
  onEmailClick = () => null,
  refetch
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { isLogin, user } = useSelector((state) => state?.authReducer);
  const { currency } = useSelector((state) => state.converterReducer);

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(false);
  const responsiveSettings = [
    { breakpoint: isMobile ? 700 : 465, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 200, settings: { slidesToShow: 1, slidesToScroll: 1 } }
  ];
  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();
  const [postApiFunc] = usePostApiMutation();

  const isFavorite = data?.favoriteBy?.includes(user?._id);

  const handleCompare = async (data) => {
    const onlyCompareEvent = user?.compareList?.filter((item) => item?.type == 'Event');
    const ifAlreadyExist = onlyCompareEvent?.find((item) => item?.entity == data?._id);
    if (!ifAlreadyExist && onlyCompareEvent?.length >= 3)
      return toast.error(t('eventCard.toast.compareEvent'));

    const response = await postApiFunc({
      url: `users/compare/add`,
      method: 'POST',
      tag: `compareListFront`,
      data: {
        id: data?._id,
        type: 'event'
      }
    });
    if (response?.data) {
      dispatch(updateUser(response?.data?.data));
      toast.success(
        `${t('eventCard.toast.event')} ${
          ifAlreadyExist ? t('eventCard.toast.removedFrom') : t('eventCard.toast.added')
        } ${t('eventCard.toast.success')}`
      );
    }
  };
  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: data?._id, type: 'event' });
    refetch && refetch();
    if (res?.data) {
      if (res?.data?.data) {
        toast.success(t('eventCard.toast.eventRemoved'));
        eventAdded;
        eventRemoved;
      } else {
        toast.success(t('eventCard.toast.eventAdded'));
      }
    }
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };
  return (
    <>
      <style>
        {`
      .${classes.sliderContainer} .react-slideshow-container .default-nav{
        background: transparent;
        color:#FFFFFF !important;
        transition: 0.5s ease;
        opacity:0;
      }
      .${classes.sliderContainer} .react-slideshow-container .default-nav svg{
        fill:#FFFFFF !important;
      }
      .${classes.sliderContainer} .react-slideshow-container .default-nav:hover{
        background: transparent;
      }

      .${classes.sliderContainer}:hover .react-slideshow-container .default-nav{
        opacity:1;
      }

              a {
          text-decoration: none;
          color: inherit;
        }
          a:hover {
            text-decoration: none;
            color: inherit;
          }
      `}
      </style>

      <div className={[classes?.propertyMain, className].join(' ')}>
        {data?.isPremium && (
          <div className={classes?.featuredPremiumContainer}>
            <span>
              <RiVipCrownFill color="#FBC56C" size={14} />
            </span>
            <span className={classes?.premiumIco}>{t('eventCard.premium')}</span>
          </div>
        )}
        {data?.isFeatured && (
          <div className={classes?.featuredContainer}>
            <span>{<TiStarFullOutline color="#FFFFFF" size={14} />}</span>

            <span className={classes?.featuredIco}>{t('eventCard.featured')}</span>
          </div>
        )}
        {/* Tag */}
        <div className={classes.iconWrapCustom}>
          <Tooltip text={t('projectCard.tooltips.compare')}>
            <div className={classes.iconBorder}>
              <BiTransfer
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  if (!handleAction()) return;
                  handleCompare(data);
                }}
                className={classes.iconsBottom}
                fill={`${
                  user?.compareList?.find((item) => item?.entity == data?._id)
                    ? 'var(--action-icon-clr)'
                    : 'white'
                } `}
              />
            </div>
          </Tooltip>
          <Tooltip
            text={
              isFavorite
                ? t('projectCard.tooltips.removeFavorite')
                : t('projectCard.tooltips.addFavorite')
            }>
            {isFavorite ? (
              <div className={classes.iconBorder}>
                <AiFillHeart
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    handleFavorite();
                  }}
                  fill="white"
                  className={classes.iconsBottom}
                />
              </div>
            ) : (
              <div className={classes.iconBorder}>
                <AiOutlineHeart
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    if (!handleAction()) return;
                    handleFavorite();
                  }}
                  fill="white"
                  className={classes.iconsBottom}
                />
              </div>
            )}
          </Tooltip>
        </div>
        {/* Tag */}
        {/* Slider */}
        <div className={classes?.sliderContainer}>
          <PhotoProvider>
            <Slide slidesToScroll={2} slidesToShow={2} responsive={responsiveSettings}>
              {data?.images?.map((image, i) => (
                <div className={classes?.propertyImageContainer} key={i}>
                  <PhotoView src={imageUrl(image)}>
                    <img src={imageUrl(image)} draggable={false} alt={`slide-${i}`} />
                  </PhotoView>
                </div>
              ))}
            </Slide>
          </PhotoProvider>
        </div>
        {/* <PhotoProvider>
          <Slide slidesToScroll={2} slidesToShow={2} responsive={responsiveSettings}>
            {data?.images?.map((image, i) => (
              <div className={classes?.propertyImageContainer} key={i}>
                <PhotoView src={imageUrl(image)}>
                  <img src={imageUrl(image)} draggable={false} alt={`slide-${i}`} />
                </PhotoView>
              </div>
            ))}
          </Slide>
        </PhotoProvider> */}

        {/* <div
            className={classes?.rightContainer}
            onClick={() => {
              navigate(`/events/${data?.slug}`);
            }}> */}
        <Link to={`/events/${data?.slug}`} className={classes?.rightContainer}>
          <div className={classes.paddingDiv}>
            {/* Price + Logo */}
            <div className={classes?.topContainer}>
              <div className={classes?.priceContainer}>
                <h6>{data?.name?.[selectedLanguage]}</h6>
                <div className={classes?.location}>
                  <img src={mapPin} width={22} height={22} alt="location" />
                  <span>{data?.address}</span>
                </div>
                {/* <span>{usdToOther({ amount: data?.price, ...currency })}</span> */}
              </div>
              <div
                className={classes?.logoContainer}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  navigate(`/company/${data?.company?.slug}`);
                }}>
                <img src={imageUrl(data?.company?.photo)} />
              </div>
            </div>

            {/* Title + Location */}
            {/* <div className={classes?.titleContainer}>
            <h6>{data?.title?.[selectedLanguage]}</h6>
            <div className={classes?.location}>
              <MdLocationPin fill="var(--text-dark-gray-clr)" />
              <span>{data?.address}</span>
            </div>
          </div> */}

            {/* Property Info */}
            <div className={classes?.propertyInfoContainer}>
              <IconList
                className={classes.infoIcons}
                Icon={HiOutlineInformationCircle}
                label={t('eventCard.tooltips.eventType')}
                value={data?.eventType?.title?.[selectedLanguage]}
                iconClass={classes.icon}
              />
              <div className={classes.divider} />
              <IconList
                className={classes.infoIcons}
                Icon={TbCalendarTime}
                label={t('eventCard.tooltips.date')}
                value={moment(data?.eventDate).format('ll')}
                iconClass={classes.icon}
              />
            </div>
          </div>

          {/* bottom strip */}
          <div className={classes?.bottomStrip}>
            {/* <div className={classes?.iconsContainer}>
            <div>
              <MdWifiCalling3 fill="#E2831B" size={30} />
            </div>
            <div>
              <GoMail fill="#E2831B" size={30} />
            </div>
            <div>
              <IoLogoWhatsapp fill="#E2831B" size={30} />
            </div>
          </div> */}
            <div className={classes.socialIconsWrap1}>
              <div className={classes.socialIcons1}>
                <Tooltip
                  text={t('eventCard.tooltips.call')}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                  href={`tel:${data?.phoneNumber}`}>
                  <MdPhoneInTalk fill="#00A997" className={classes.iconsBottom} />
                </Tooltip>
              </div>
              <div
                className={[classes.socialIcons1, classes.midIcon].join(' ')}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  onEmailClick && onEmailClick();
                }}>
                <Tooltip text={t('eventCard.tooltips.email')}>
                  <MdEmail fill="#00A997" className={classes.iconsBottom} />
                </Tooltip>
              </div>
              <div className={classes.socialIcons1}>
                <Tooltip
                  text={t('eventCard.tooltips.whatsapp')}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                  href={`https://wa.me/${data?.whatsapp}`}
                  target="_blank">
                  <IoLogoWhatsapp fill="#00A997" className={classes.iconsBottom} />
                </Tooltip>
              </div>
            </div>
            {/* right */}
            <span className={classes.currency}>
              {data?.price > 0
                ? usdToOther({ amount: data?.price, ...currency })
                : t('eventCard.openInvitation')}
            </span>
            {/* <div className={classes.iconWrap}>
              <Tooltip text={t('eventCard.tooltips.compare')}>
                <BiTransfer
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    if (!handleAction()) return;
                    handleCompare(data);
                  }}
                  className={classes.iconsBottom}
                  fill={
                    user?.compareList?.find((e) => e?.entity == data?._id)
                      ? 'var(--action-icon-clr)'
                      : 'var(--text-light-gray-clr)'
                  }
                />
              </Tooltip>
              <Tooltip
                text={
                  isFavorite
                    ? t('eventCard.tooltips.removeFavorite')
                    : t('eventCard.tooltips.addFavorite')
                }>
                {isFavorite ? (
                  <AiFillHeart
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      handleFavorite(false);
                    }}
                    fill="var(--action-icon-clr)"
                    className={classes.iconsBottom}
                  />
                ) : (
                  <AiOutlineHeart
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      if (!handleAction()) return;
                      handleFavorite(true);
                    }}
                    fill="var(--text-light-gray-clr)"
                    className={classes.iconsBottom}
                  />
                )}
              </Tooltip>
            </div> */}
          </div>
        </Link>

        {/* </div> */}

        {/* <div className={classes?.featuredPremiumContainer}>
          <span className={`${index % 2 === 0 ? classes?.featuredIco : classes?.premiumIco}`}>
            {index % 2 === 0 ? 'Featured' : 'Premium'}
          </span>
        </div> */}
      </div>
    </>
  );
};

export default EventHorizontalCard;
